const tag = {
  baseStyle: {
    container: {
      borderRadius: '999px',
      whiteSpace: 'nowrap'
    }
  },
  sizes: {
   md: {
    container: {
      h: '20px',
      p: '2px 8px',
    },
    label: {
      fontSize: '12px',
      fontWeight: 'medium',
      lineHeight: '16px',
      
    }
   }
  }
};

export default tag;
